import { MatDialogConfig } from '@angular/material/dialog';
import { EDRPOUErrors } from '../../errors/error-messages';
import { PhoneMask } from '@core';

export const ControlNames = {
  Phone: 'phone',
  EDRPOU: 'edrpou',
};

export const phoneErrors = {
  required: 'Це поле обов\'язкове',
  minlength: 'Занадто короткий номер',
  notMatch: 'Телефон не співпадає з номером відправника чи отримувача. Уточніть дані',
  notFound: 'Не вдалося знайти інформацію за вказаним номером',
};

export const becomePayerEDRPOUErrors = {
  ...EDRPOUErrors,
  minlength: 'Має містити 8-10 цифр',
  maxlength: 'Має містити 8-10 цифр',
  notFound: 'Організація не існує або неправильно вказано код ЄДРПОУ',
};

export const PhoneMaskConfig = {
  mask: PhoneMask,
  guide: false,
};

export const becomePayerDialogConfig: MatDialogConfig = {
  panelClass: 'no-padding',
  width: '440px',
  position: { right: '0' },
  height: '100%',
  autoFocus: false,
  restoreFocus: false,
};
